import React from "react";

import { Icon, IconProps } from "../";

export const FileNoteIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.196 21.021 4 20.55 4 20V4C4 3.45 4.196 2.97901 4.588 2.58701C4.97933 2.19567 5.45 2 6 2H13.175C13.4417 2 13.696 2.04999 13.938 2.14999C14.1793 2.24999 14.3917 2.39166 14.575 2.575L19.425 7.425C19.6083 7.60834 19.75 7.82066 19.85 8.062C19.95 8.304 20 8.55833 20 8.825V20C20 20.55 19.8043 21.021 19.413 21.413C19.021 21.8043 18.55 22 18 22H6ZM13.5 7.52827V3.5H6.25C5.83579 3.5 5.5 3.83579 5.5 4.25V19.75C5.5 20.1642 5.83579 20.5 6.25 20.5H17.75C18.1642 20.5 18.5 20.1642 18.5 19.75V8.5L14.5 8.52827C14.2167 8.52827 13.9793 8.43228 13.788 8.24028C13.596 8.04895 13.5 7.81161 13.5 7.52827Z"
      />
    </Icon>
  );
};
